import { Component} from '@angular/core';
import {ToolsService} from '@app/services/tools/tools.service';
import { fbShare , tw, email} from 'vanilla-sharing';


@Component({
  selector: 'app-sharer',
  templateUrl: './sharer.component.html',
  styleUrls: ['./sharer.component.scss']
})
export class SharerComponent  {

  isSharedOpen = false;
  facebookAppId = '';

  constructor(public tools: ToolsService) {}

  // SOCIAL SHARING

  onClickToggleShare() {
    this.isSharedOpen = !this.isSharedOpen;
  }

  // FIX ME : CHANGE INFORMATIONS
  onCliskSocials(type) {
    switch (type) {
      case 'facebook':
        fbShare({
          url: window.location.href,
          fbAppId: this.facebookAppId
        });
        break;
      case 'twitter':
        tw({
          url: window.location.href,
          title: this.tools.document.title
        });
        break;
      case 'email':
        email({
          url: window.location.href,
          title: this.tools.document.title
        });
        break;
    }
  }
}
